import { merge } from 'lodash';
import Sound from './Sound';

export default class GamesVisAudio {
  constructor(settings = {}) {
    this.settings = {
      enabled: true,
      paths: [],
      muted: false,
    };

    this.sounds = [];

    this.updateSettings(settings);
  }

  preload(list = []) {
    const self = this;
    return new Promise(async (resolve) => {
      let counter = 0;
      async function load(audio) {
        try {
          await self.add(audio);
          counter += 1;
          if (counter === list.length) {
            resolve();
          } else {
            load(list[counter]);
          }
        } catch (error) {
          console.error(error);
        }
      }

      load(list[counter]);
    });
  }

  add(settings = {}) {
    return new Promise((resolve, reject) => {
      let { name } = settings;
      const { path } = settings;
      const { muted } = this.settings;

      if (path || name) {
        if (!name) {
          name = this.getNameFromPath(path);
        }

        const exists = this.find(name);
        if (!exists) {
          try {
            const sound = new Sound(merge(settings, { name, path, muted }));
            this.sounds.push(sound);

            // This event indicates sound has completely loaded
            // and available to play to the end without interruptions
            sound.audio.addEventListener('canplaythrough', () => {
              resolve(sound);
            });
          } catch (error) {
            reject(error);
          }
        }
      }
    });
  }

  enable(name) {
    const sound = this.find(name);
    if (sound) {
      sound.enabled = true;
    } else {
      this.settings.enabled = true;
    }
  }

  disable(name) {
    const sound = this.find(name);
    if (sound) {
      sound.enabled = false;
    } else {
      this.settings.enabled = false;
    }
  }

  play(settings = {}) {
    const sound = this.find(settings.name);
    if (sound) {
      if (this.settings.enabled) {
        sound.play(settings);
      }
    }
  }

  pause(name) {
    const sound = this.find(name);
    if (sound) {
      sound.pause();
    }
  }

  stop(settings = {}) {
    const { name } = settings;

    if (name) {
      const sound = this.find(name);
      if (sound) {
        sound.stop();
      }
    } else {
      this.sounds.forEach((sound) => {
        sound.stop();
      });
    }
  }

  updateSettings(settings = {}) {
    merge(this.settings, settings);
    this.sounds.forEach((sound) => {
      sound.updateSettings({
        muted: this.settings.muted,
        volume: this.settings.muted ? 0 : sound.settings.originalVolume,
      });
    });
  }

  find(name) {
    return this.sounds.find((sound) => sound.settings.name === name);
  }

  destroy() {
    this.sounds.forEach((sound) => {
      sound.pause();
      sound.destroy();
    });

    this.sounds = [];
  }

  /**
   * TODO: Move to utility
   * Get name from path
   */
  // eslint-disable-next-line class-methods-use-this
  getNameFromPath(path) {
    if (path) {
      return path
        .split('/')
        .pop()
        .split('.')
        .shift();
    }

    return '';
  }
}
